/**
 * Restaura botões Comprar / Carrinho ao voltar do checkout (bfcache).
 * Script clássico (sem module) — sempre ativo após pageshow/pagehide.
 */
(function () {
  var SELECTOR = '[data-md-buy-now], [data-md-sticky-buy-now]';

  function clearBusyDom() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      btn.classList.remove('md-pdp__btn--busy');
      btn.removeAttribute('aria-busy');
      delete btn.dataset.mdSubmitting;
    });
  }

  function resetAll() {
    clearBusyDom();
    if (window.BelabellyPdpCommerce && typeof window.BelabellyPdpCommerce.resetInstances === 'function') {
      window.BelabellyPdpCommerce.resetInstances();
    }
  }

  window.addEventListener('pageshow', resetAll);
  window.addEventListener('pagehide', clearBusyDom);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetAll();
  });

  window.BelabellyPdpCommerce = window.BelabellyPdpCommerce || {};
  window.BelabellyPdpCommerce.hardReset = resetAll;
})();
